import {  
    debounce, 
    filter, 
    findIndex } from 'lodash';
import { createNode } from '../../js/helpers.js';

// eslint-disable-next-line no-undef
const mapType = map_block_object.map_type;

// eslint-disable-next-line no-undef
const layout = map_block_object.layout;

const debounceDelay = 800;
let apiFilters,
    activePanel,
    activePaneText,
    isGridView,
    isMapView;

function events() {
    const blockMap = document.querySelector('.block-map');
    const filterContainer = blockMap.querySelector('.block-map__filters');

    const inputMapSearch = blockMap.querySelector('.form-control.map-search');
    const btnLoadMore = blockMap.querySelector('.load-more');
    const btnGroupView = filterContainer.querySelector('.view');

    // init category event filter
    initCategoryEventFilter(filterContainer);

    // location filter
    // if(mapType === 'locations') initLocationEventFilter(filterContainer);

    // Search Input
    inputMapSearch.addEventListener(
        'input',
        debounce((e) => {
            const target = e.target;

            apiFilters.search = target.value;
            if(apiFilters.paged) apiFilters.paged = 0;

            target.parentNode.classList.add('is-searching');

            const searchService = {
                grid: () => {
                    import('./map-grid.js').then(grid => {
                        grid.filterGridMap(apiFilters);
                    });
                },
                map: () => {
                    // Search by Post Field
                    // import('./map.js').then(map => {
                    //     map.filterMap(apiFilters).then(() =>{
                    //         target.parentNode.classList.remove('is-searching');
                    //     });
                    // });

                    // Search by google
                    import('./map.js').then(map => {
                        map.searchLocationGoogleMap(target.value).then(() => {
                            target.parentNode.classList.remove('is-searching');
                        }).catch(() => {
                            target.parentNode.classList.remove('is-searching');
                        });
                    });
                }
            }

            searchService[activePaneText]();

        }, debounceDelay)
    );


    inputMapSearch.addEventListener('click', () => {
        if(activePaneText !== 'map') return;

        import('./map.js').then(map => {
            map.closeMobileInfo();
        });

    });

    // // Load more post
   if(btnLoadMore) {
        btnLoadMore.addEventListener('click', () =>{
            if(!apiFilters.paged) apiFilters.paged = 1;

            apiFilters.paged++;

            import('./map-grid.js').then((grid) => {
                grid.loadMorePost(apiFilters);
            });
        });
   }

    // // Map View / Grid View Selection Event
    if(btnGroupView) {
        btnGroupView.querySelectorAll('.wp-element-button').forEach((btn) => {
            btn.addEventListener('click', (event) => {
                const target = event.currentTarget;
                const toggle  = target.dataset.toggle;
    
                activePaneText = target.dataset.label;
    
                target.parentNode.querySelectorAll('.wp-element-button').forEach(button => button.classList.remove('is-selected'));
                target.classList.add('is-selected');
    
                if(activePanel) activePanel.classList.remove('is-selected');
    
                activePanel = blockMap.querySelector(`#${toggle}`);
                activePanel.classList.add('is-selected');
    
    
                if(apiFilters.paged) apiFilters.paged = 0;
    
                apiFilters.search = '';
                inputMapSearch.value = '';
    
                const viewService = {
                    map: () => {
                        blockMap.classList.add('is-map-view');
                        blockMap.classList.remove('is-grid-view');
    
                        if(!isMapView) {
                            import('./map.js').then(map => {
                                map.init();
                                map.filterMap(apiFilters);
                                isMapView = true;
                             });
                        }else {
                            import('./map.js').then(map => {
                                map.filterMap(apiFilters);
                             });
                        }
                    },
                    grid: () => {
                        blockMap.classList.remove('is-map-view');
                        blockMap.classList.add('is-grid-view');
                        
                        if(!isGridView) {
                            import('./map-grid.js').then(grid => {
                                grid.init(apiFilters);
                                grid.filterGridMap(apiFilters);
                                
                                isGridView = true;
                            });
                        }else {
                            import('./map-grid.js').then(grid => {
                                grid.filterGridMap(apiFilters);
                            });
                        }
    
                        import('./map.js').then(map => {
                            map.closeMobileInfo();
                            map.closeLargeInfo();
                        });
    
                    }
                }
                // import grid/map module
                viewService[activePaneText]();
            })
        })
    }
}

function initVariables() {
    const blockMap = document.querySelector('.block-map');
    const panel = blockMap.querySelectorAll('.block-map__panel.is-selected');

    apiFilters = {
        post_type: mapType
    }

    activePanel = panel[0];
    activePaneText = layout ?? 'map';
}

// eslint-disable-next-line no-unused-vars
function initLocationEventFilter(filterContainer) {
    const locationFilter = filterContainer.querySelector('.dropdown.location');
    const locations = locationFilter.querySelectorAll('.dropdown-menu .dropdown-item');
    const selectedCategoryContainer = filterContainer.querySelector('.dropdown.location .dropdown-toggle p');

   
    for(const location of locations) {
        location.addEventListener('click', (event) => {
            const target = event.currentTarget;
            const postId = target.dataset.postId;

            // eslint-disable-next-line no-shadow
            const isMapView = target.parentNode.parentNode.parentNode.parentNode.parentNode.classList.contains('is-map-view');

            const title = target.textContent;
            selectedCategoryContainer.textContent = title;

            setActiveDropdown(target);

            if(isMapView) {
                import('./map.js').then(map => {
                    const posts = map.getPosts();
                    const selectedPost = filter(posts,{post_id: +postId });
    
                    if(selectedPost.length > 0) {
                        map.setPostInfo(selectedPost[0]);
                        map.setActiveMarker(findIndex(posts, {post_id: +postId}));
                    }
                });
            }else {
                apiFilters.post_id = postId;

                import('./map-grid.js').then(grid => {
                    grid.filterGridMap(apiFilters);

                    delete apiFilters.post_id;
                }); 
            }
        });
    }
}


function initCategoryEventFilter(filterContainer) {
    const categoryFilter = filterContainer.querySelector('.dropdown.category');
    const categories = categoryFilter.querySelectorAll('.dropdown-menu .dropdown-item');
    const selectedCategoryContainer = filterContainer.querySelector('.dropdown.category .dropdown-toggle p');
    const inputMapSearch = filterContainer.parentNode.querySelector('.block-map__container .form-control.map-search');

    for(const category of categories) {
        category.addEventListener('click', (event) => {
            const target = event.currentTarget;

            setActiveDropdown(target);
            
            const slug = target.dataset.slug;
            const title = target.textContent;

            selectedCategoryContainer.textContent = title;

            apiFilters.category = slug;

            apiFilters.search = ''
            inputMapSearch.value = '';
            
            if(!slug) delete apiFilters.category;

            if(apiFilters.paged) apiFilters.paged = 0;
            
            const categoryService = {
                grid: () => {
                    import('./map-grid.js').then(grid => {
                        grid.filterGridMap(apiFilters);
                    });
                },
                map: () => {
                    import('./map.js').then(map => {
                        map.filterMap(apiFilters);
                    });
                }
            }

            categoryService[activePaneText]();

            //
            // if(mapType === 'locations') {
            //     const locationFilter = filterContainer.querySelector('.dropdown.location');
            //     setLocationFilter(locationFilter);
            // }
        });
    }
}

//----------------------------------------------------
const setActiveDropdown = (dropdown) => {
    // remove previous selected
    dropdown.parentNode.parentNode.querySelector('li span.is-selected').classList.remove('is-selected');
    dropdown.classList.add('is-selected');
}

// eslint-disable-next-line no-unused-vars
function setLocationFilter(filterContainer) {
    const container = filterContainer;

    const dropdownMenu = container.querySelector('.dropdown-menu');
    const locationFilter = container.querySelector('.dropdown-toggle.location');
    const selectedLocationContainer = locationFilter.querySelector('p');

    locationFilter.classList.add('is-loading');
    locationFilter.setAttribute('disabled', true);

    import('./map.js').then(map => {
        
        map.filterMap(apiFilters).then( posts => {
        
        locationFilter.classList.remove('is-loading');
        locationFilter.setAttribute('disabled', false);

        if(posts.length > 0) {
            dropdownMenu.innerHTML = '';

            let spanNode,
                // eslint-disable-next-line no-unused-vars
                initialLocation;

            posts.forEach((post, index) => {
                if(index === 0) {
                    spanNode = createNode({
                        type: 'span',
                        class: ['dropdown-item', 'is-selected'], 
                        textContent: post.title,
                        attribute: {
                            'data-post-id': post.post_id
                        }
                    });

                    selectedLocationContainer.textContent = post.title;
                    initialLocation = post;
                }else {
                    spanNode = createNode({
                        type: 'span',
                        textContent: post.title,
                        class: 'dropdown-item',
                        attribute: {
                            'data-post-id': post.post_id
                        }});
                };

                const listNode = createNode({type: 'li'});
                listNode.appendChild(spanNode);
                dropdownMenu.appendChild(listNode);
            });

            // initLocationEventFilter(filterContainer.parentNode);
        }
        });
    });
}

document.addEventListener( 'DOMContentLoaded', () => {
    initVariables();
    events();
        
    // -----------------------------------------------
    switch(layout) {
        case 'grid':
            import('./map-grid.js').then(grid => {
                grid.init(apiFilters);
                isGridView = true;
            });
            break;

        case 'map':
            import('./map.js').then(map => {
                map.init();
                isMapView = true;
             });
            break;

        default:
            import('./map.js').then(map => {
                map.init();
                isMapView = true;
             });
            break;
    }
} );